import React from 'react';
import {
  View,
  Text,
  Platform,
  Image,
  TouchableOpacity,
  // TouchableOpacity,
} from 'react-native';
import Svg, {
  Circle, Text as SvgText, Line,
} from 'react-native-svg';
import PropTypes from 'prop-types';
// import { translate } from '../../locales/i18n';
// import AORTypes from '../../types';
import styles from '../../styles';

import removeIcon from '../../assets/images/glyphicons-remove-circle.png';

class PivotPointBadge extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(_prevProps, _prevState) {
  }

  render() {
    const {
      idx, point,
      // getAnalyticsService,
      del,
      onDel,
    } = this.props;
    // const {
    // } = this.state;

    return (
      // <TouchableOpacity
      //   style={[styles.endpointBadge.panel, {
      //     flex: 1,
      //     flexDirection: 'column',
      //     marginHorizontal: 0,
      //   }]}
      //   onPress???={ /* needs a ref from the MiniPlayer and a way to trigger it */ }
      // >
      <View
        style={styles.endpointBadge.panel}
      >
        {Platform.OS === 'web' && (
          <>
            {/* SEO tags */}
            {/* <meta itemProp="name" content={`${point.lat}, ${point.lon}`} /> */}
            {/* <meta itemProp="publicAccess" content="true" /> */}
            {/* TODO(clairbee): pass 'app': {app.data.travelType === 2 && (
              <meta itemProp="hasDriveThroughService" content="true" />
            )} */}
          </>
        )}

        <View style={styles.endpointBadge.blockPoint}>
          <Svg height="100%" width="100%" viewBox="0 0 40 40">
            <Circle
              cx="20"
              cy="20"
              r="10"
              fill={styles.primaryColor}
            />
            <SvgText
              x="20"
              y="23"
              stroke="white"
              fill="white"
              fontSize="10"
              fontWeight="500"
              textAnchor="middle"
              fontFamily="Rubik"
            >
              {idx >= 0 ? idx : ''}
            </SvgText>
          </Svg>
          {idx !== -1 && (
            <Svg style={{ position: 'absolute', left: 14, top: 39 }} width="12" height="90" viewBox="0 0 12 90">
              <Line
                x1="6"
                y1="2"
                x2="6"
                y2="48"
                stroke={styles.primaryColor}
                strokeWidth={4}
                strokeDasharray={[6, 4]}
                strokeDashoffset={0}
              />
            </Svg>
          )}
        </View>
        <View style={styles.endpointBadge.panelInner}>
          <View style={styles.endpointBadge.namePanel}>
            <Text style={styles.endpointBadge.name} numberOfLines={1}>
              {point.name}
            </Text>
            {del && (
              <TouchableOpacity
                style={{
                  width: 14,
                  height: 14,
                  alignSelf: 'center',
                }}
                onPress={() => onDel()}
              >
                <Image
                  source={removeIcon}
                  style={{
                    width: 14,
                    height: 14,
                    alignSelf: 'center',
                  }}
                />
              </TouchableOpacity>
            )}
          </View>
        </View>
      </View>
      // </TouchableOpacity>
    );
  }
}

PivotPointBadge.defaultProps = {
  del: false,
  onDel: () => { },
};

PivotPointBadge.propTypes = {
  point: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  idx: PropTypes.number.isRequired,
  // getAnalyticsService: PropTypes.func.isRequired,
  del: PropTypes.bool,
  onDel: PropTypes.func,
};

export default PivotPointBadge;
